module.exports = __webpack_public_path__ + "static/media/br-ro.64753728.svg";